export default {
	"Timezone": "Fuso horário",
	"Sample Record": "Amostras",
	"Sync Normal": "Sincronização Normal",
	"SOS Phone": "SOS Telefone",
	"Offline Timer": "Temporizador offline",
	"Fall Detection": "Detecção de Quedas",
	"Reference Systolic": "Referência Sistólica",
	"Reference Diastolic": "Referência Diastólica",
	"Heart Rate Min": "Frequência Cardíaca mín.",
	"Heart Rate Max": "Frequência Cardíaca máx.",
}


// WEBPACK FOOTER //
// ./src/i18n/configurations/configurations_pt.js